import { useState } from 'react'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { AnimatePresence } from 'framer-motion'
import { AuthProvider } from '@shared/stores/AuthContext'
import SiteLoader from '@shared/components/SiteLoader'
import InstallPrompt from '@shared/components/InstallPrompt'
import PWAReloadPrompt from '@shared/components/PWAReloadPrompt'
import router from './router'

const qc = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 30 * 1000, retry: 1, refetchOnWindowFocus: false }
    }
})

export default function App() {
    const [loading, setLoading] = useState(true)

    return (
        <QueryClientProvider client={qc}>
            <AuthProvider>
                <AnimatePresence>
                    {loading && <SiteLoader key="site-loader" onComplete={() => setLoading(false)} />}
                </AnimatePresence>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        duration: 4000,
                        style: { fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '0.875rem' },
                        success: { iconTheme: { primary: '#10b981', secondary: '#fff' } },
                        error: { iconTheme: { primary: '#ef4444', secondary: '#fff' } }
                    }}
                />
                <RouterProvider router={router} />
                <InstallPrompt />
                <PWAReloadPrompt />
            </AuthProvider>
        </QueryClientProvider>
    )
}
